import React from 'react';
import { BodySmallEmphasized } from 'smoothie';

export const TextError = ({ message }: { message: string }) => {
    return (
        <BodySmallEmphasized color="$red1100" marginVertical="auto">
            {message ?? 'Oops! Something went wrong.'}
        </BodySmallEmphasized>
    );
};
